/*
  此公共方法为创建订单、支付，支付完成回调判断。非全局引入。若页面涉及支付则引入此文件
  mixins方法和变量均带有$符号，防止覆盖
*/
import Toast from 'vant/lib/toast'
import 'vant/lib/toast/style'
import PayLoading from '@/components/PayLoading'

import { api_createOrder, api_getPaymentUrl, api_queryOrderState } from '@/api/order.js'

const PAYCODEKEY = '7DayPayCode'

export default {
  components: {
    PayLoading
  },
  data() {
    return {
      // 可通过watch payLoading 是否为false判定支付结果获取完成的回调
      payLoading: false, // 此字段判断支付完成后的加载订单状态Loading，注：此字段命名不能加$否则会监听不到
      $payCode: '',
      $payResultMaxTime: 5 // 循环获取订单状态的最大次数
    }
  },
  created() {
    this.$payCode = window.localStorage.getItem(PAYCODEKEY)
    if (this.$payCode) {
      if (this.$route.query.payCode) {
        // 若本地发现了 7DayPayCode 则说明刚支付过。
        this.payLoading = true
        this.$getPayResult()
      }
      window.localStorage.removeItem(PAYCODEKEY)
    }
  },
  methods: {
    $createOrder(params) {
      // 创建订单
      return new Promise((resolve, reject) => {
        api_createOrder(params).then(res => {
          if (res.status === 200) {
            // state 为 2 说明课程免费, 直接刷新页面
            if (res.data.state == 2) {
              resolve()
              document.location.reload(true)
              return
            }
            let query = this.$route.query
            if (query.payCode) delete query.payCode // 避免多个 payCode 参数
            let callbackurl = window.location.href.split('?')[0] + '?' + $.param(query)
            let reg = /&page=septnetstudent%3A%2F%2F[liveroom|course].+&/
            let reg2 = /&from=singlemessage&?/
            let href = callbackurl
            href = href.replace(reg,'&').replace(reg2,'&')
            // 获取支付链接
            api_getPaymentUrl({
              orderCode: res.data.orderCode,
              callbackurl: (href + '&payCode=' + res.data.orderCode),
              openid: this.$store.state.openid,
              payWay: 0
            }).then(rt => {
              if (rt && rt.status === 200) {
                // 本地保存订单号, 用于支付完成后定时请求结果
                resolve()
                window.localStorage.setItem(PAYCODEKEY, res.data.orderCode)
                window.location.href = rt.data.jumpPage
              } else {
                reject()
                Toast({ message: '获取支付链接失败', duration: 2000 })
              }
            }).catch((e) => {
              console.error(e)
              reject(e)
            })
          } else {
            reject()
            Toast({ message: '创建订单失败', duration: 2000 })
          }
        }).catch((e) => {
          console.error(e)
          reject(e)
        })
      })
    },
    $getPayResult() {
      // 循环获取订单状态， 最多5次
      api_queryOrderState({
        orderCode: this.$payCode
      }).then(res => {
        if (res.data) {
          this.payLoading = false
        } else if (this.$payResultMaxTime > 0) {
          this.$payResultMaxTime--
          setTimeout(() => {
            this.$getPayResult()
          }, 5000)
        } else {
          // 5次都没请求到， 直接结束
          this.payLoading = false
          Toast({ message: '非常抱歉, 未获取到订单结果, 请稍后刷新看看...', duration: 2000 })
        }
      })
    }
  }
}
